module.exports = __webpack_public_path__ + "img/HC1021-169.90f48780.jpg";